<input type="number" ngDefaultControl nbInput [placeholder]="placeholder" fullWidth />
